// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-content {
  margin-top: 60px;
  padding-top: 75px;
  margin-bottom: 20px;
}
.nav-link {
  padding: 6px 8px !important;
}
.nav-link.active {
  background-color: #000;
  color: #fff !important;
}
.tabs-container {
  position: fixed;
  width: 100%;
  top: 0px;
  margin-top: 60px;
  background: #ebebeb;
  padding: 10px 0px;
  border-bottom: 1px solid #dfdfdf;
  z-index: 99;
}
.loaderParent {
  min-height: calc(100vh - 243px) !important;
  height: auto !important;
}
.subNav {
  margin: auto !important;
  background: none !important;
  box-shadow: 0 0px 0px 0px rgba(255, 255, 255, .0) !important;
  color: #000 !important;
}
.page-title {
  font-size: 24px !important;
  font-weight: 500 !important;
  margin-bottom: 20px !important;
}
.card-title {
  font-size: 18px !important;
  font-weight: 500 !important;
  margin: 0px 0px 15px !important;
}
@media (max-width: 767px) {
  .tabs-container {
    margin-top: 61.5px;
  }
  .nav-tab {
    width: 100%;
    white-space: nowrap;
    overflow: auto;
  }
  .nav-link {
    font-size: 12px !important;
  }
  .page-content {
    padding-top: 70px;
    margin-top: 61.5px;
  }
}

.insta-btn a {
  display: flex;
}
.insta-btn {
  padding: 6px 8px;
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/yacht/home/Home.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,WAAW;EACX,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,0CAA0C;EAC1C,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,4DAA4D;EAC5D,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;AACjC;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".page-content {\n  margin-top: 60px;\n  padding-top: 75px;\n  margin-bottom: 20px;\n}\n.nav-link {\n  padding: 6px 8px !important;\n}\n.nav-link.active {\n  background-color: #000;\n  color: #fff !important;\n}\n.tabs-container {\n  position: fixed;\n  width: 100%;\n  top: 0px;\n  margin-top: 60px;\n  background: #ebebeb;\n  padding: 10px 0px;\n  border-bottom: 1px solid #dfdfdf;\n  z-index: 99;\n}\n.loaderParent {\n  min-height: calc(100vh - 243px) !important;\n  height: auto !important;\n}\n.subNav {\n  margin: auto !important;\n  background: none !important;\n  box-shadow: 0 0px 0px 0px rgba(255, 255, 255, .0) !important;\n  color: #000 !important;\n}\n.page-title {\n  font-size: 24px !important;\n  font-weight: 500 !important;\n  margin-bottom: 20px !important;\n}\n.card-title {\n  font-size: 18px !important;\n  font-weight: 500 !important;\n  margin: 0px 0px 15px !important;\n}\n@media (max-width: 767px) {\n  .tabs-container {\n    margin-top: 61.5px;\n  }\n  .nav-tab {\n    width: 100%;\n    white-space: nowrap;\n    overflow: auto;\n  }\n  .nav-link {\n    font-size: 12px !important;\n  }\n  .page-content {\n    padding-top: 70px;\n    margin-top: 61.5px;\n  }\n}\n\n.insta-btn a {\n  display: flex;\n}\n.insta-btn {\n  padding: 6px 8px;\n  margin-right: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
